__turbopack_context__.v({
  "cta": "IntegrationSolutions-module__kBG22W__cta",
  "eyebrow": "IntegrationSolutions-module__kBG22W__eyebrow",
  "grid": "IntegrationSolutions-module__kBG22W__grid",
  "icon": "IntegrationSolutions-module__kBG22W__icon",
  "label": "IntegrationSolutions-module__kBG22W__label",
  "left": "IntegrationSolutions-module__kBG22W__left",
  "section": "IntegrationSolutions-module__kBG22W__section",
  "subtitle": "IntegrationSolutions-module__kBG22W__subtitle",
  "tile": "IntegrationSolutions-module__kBG22W__tile",
  "title": "IntegrationSolutions-module__kBG22W__title",
  "wrap": "IntegrationSolutions-module__kBG22W__wrap",
});
